import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import React from 'react';
import { createTheme } from '@mui/material/styles';
import {
  componentsOverrides,
  selectedLocale,
} from '../../../theme/ThemeProviderWithTheme';

export const theme = createTheme(
  {
    palette: {
      primary: {
        main: '#0c3188',
      },
      secondary: {
        // Nav color
        main: '#e1e2e1',
      },
    },
    components: componentsOverrides,
  },
  selectedLocale.muiCore,
  selectedLocale.muiDatePicker,
  selectedLocale.muiDataGrid
);

export default function ThemeProviderWithTheme({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </StyledEngineProvider>
  );
}
